import React from 'react';
import { Link } from 'react-router-dom';

const ContentSection = () => {
  const sections = [
    {
      id: 'how-it-works',
      title: 'How It Works',
      content: 'JS360 simplifies private flight booking, offering travellers a seamless and intuitive way to access the world of private aviation.',
      description: 'At JS360, we eliminate complexities and provide a seamless, private, and tailored air travel experience—all just a few clicks away.',
      image: '/howitworks.jpeg',
      imageAlt: 'Couple enjoying luxury flight experience',
      reverse: false,
      link: '/how-it-works'
    },
    {
      id: 'what-we-do',
      title: 'What We Do',
      content: 'JS360 is a concierge-level private aviation service designed to provide seamless and flexible air travel. Our platform connects you with a global network of private aircraft operators, allowing you to effortlessly book flights tailored to your schedule, destination, and preferences.',
      description: 'With JS360, you fly on your terms.',
      image: '/whatwedo.jpeg',
      imageAlt: 'Luxury private jet interior',
      reverse: true,
      link: '/what-we-do'
    },
    {
      id: 'who-we-are',
      title: 'Who we Are',
      content: 'At Jetscanner360 (JS360), we are a team of aviation professionals with extensive experience in ground handling, trip support, and private jet operations. Our goal is to create a seamless and elevated private aviation experience.',
      description: "It's a meticulously crafted private aviation marketplace tailored to the needs of modern air travelers.",
      image: '/whoweare.jpeg',
      imageAlt: 'Aviation technology and planning',
      reverse: false,
      link: '/who-we-are'
    }
  ];

  return (
    <div className="bg-[#F8F9FC] py-8">
      {sections.map((section, index) => (
        <section 
          key={section.id} 
          className={` ml-[7.2%] mr-[7%] bg-white rounded-[10px] mt-[25px] ${index !== sections.length - 1 ? 'mb-8' : ''}`}
        >
          <div className="p-4">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}>
              {/* Text Content */}
              <div className={`max-w-[500px] ${section.reverse ? 'lg:order-2' : 'lg:order-1'} text-center lg:text-left`}>
                <h2 className="font-semibold text-jet-gray-800 mb-6">
                  {section.title}
                </h2>
                <p className="text-[18px] mb-4">
                  {section.content}
                </p>
                <p className="text-[18px] mb-8">
                  {section.description}
                </p>
                <Link 
                  to={section.link}
                  className="text-[0.875rem] text-center inline-block bg-jet-yellow text-black h-[36px] w-[156px] py-[10px] px-4 leading-[14.8px] rounded-lg font-semibold hover:bg-jet-yellow-hover transition-colors duration-300 capitalize focus:outline-2 focus:outline-offset-2 focus:outline-jet-yellow"
                  style={{ fontFamily: "'Bahnschrift', sans-serif" }}
                >
                  Read More
                </Link>
              </div>
              
              {/* Image */}
              <div className={`relative ${section.reverse ? 'lg:order-1' : 'lg:order-2'}`}>
                <img 
                  src={section.image} 
                  alt={section.imageAlt}
                  className={`w-full h-[300px] object-cover rounded-[10px] shadow-[0_10px_30px_rgba(0,0,0,0.1)] ${
                    section.id === 'how-it-works' ? 'border-0 border-[#ffd200] pr-[2px]' : ''
                  }`}
                />
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default ContentSection;